import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOut } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import useEntityImpersonation from '@hooks/useEntityImpersonation'
import type { EntityModel } from '@hooks/useEntityImpersonation'

import LoginAsEntityButton from '@components/LoginAsEntityButton'

interface ImpersonateEntityButtonProps {
  callbacks?: {
    loginAsEntity: VoidFunction,
  },
  children?: React.ReactNode,
  entity: EntityModel,
  iconOnly?: boolean,
  redirectPath?: string,
  requestOptions?: object,
  [key: string]: any,
}

const ImpersonateEntityButton = (props: ImpersonateEntityButtonProps) => {
  const {
    callbacks,
    children,
    entity,
    iconOnly,
    redirectPath,
    requestOptions,
    ...restProps
  } = props

  const entityImpersonationPayload = useEntityImpersonation(entity)
  const {
    callbacks: {
      generateTokenAndImpersonate,
    },
    loading,
    realhubPlatform,
  } = entityImpersonationPayload

  if (realhubPlatform === 'legacy' && callbacks?.loginAsEntity){
    return (
      <LoginAsEntityButton
        callbacks={{ loginAsEntity: callbacks.loginAsEntity }}
        requestOptions={requestOptions}
        {...restProps}
      >
        {children || iconOnly || 'Login (Legacy)'}
      </LoginAsEntityButton>
    )
  }

  return (
    <Button
      buttonStyle="secondaryEdit"
      icon={<FontAwesomeIcon icon={faSignOut} />}
      loading={loading}
      onClick={() => generateTokenAndImpersonate({
        entity,
        redirectPath,
      })}
      size="medium"
      //@ts-expect-error
      width="auto"
      {...restProps}
    >
      {children || iconOnly || 'Login'}
    </Button>
  )
}

export default ImpersonateEntityButton
